import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const MauritiusPage = () => {
  return <DestinationTemplate destinationId="mauritius" />;
};

export default MauritiusPage;
